module.exports = __webpack_public_path__ + "static/img/12.fb4d105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/doublelift/12.png
// module id = fb6z
// module chunks = 35